import { TablePagination as MuiTablePagination } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const TablePagination = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const mobileStyles = {
    // Style de l'ensemble de la barre de pagination
    '.MuiTablePagination-toolbar': { pl: 0.5 },
    // Style du sélecteur de nombre de lignes par page
    '.MuiTablePagination-select': {
      mr: 0.5,
      pr: 0.5,
      // Style du sélecteur du menu déroulant
      '& .MuiSelect-select': { pr: '6px !important' }
    },
    // Style des boutons de navigation entre les pages
    '.MuiTablePagination-actions': {
      ml: '0 !important'
    }
  };

  return <MuiTablePagination {...props} sx={isMobile && mobileStyles} />;
};

export default TablePagination;
